import { styled } from '@zoopla-eng/zds-components/themes';

export const NotificationIconContainer = styled('div', {
    display: 'inline-flex',
    borderRadius: '100%',
    p: '$S200',
    marginRight: '$S400',
    color: '$graphicIconsDark',

    variants: {
        iconColor: {
            purple: {
                backgroundColor: '$brandPrimaryT3'
            },
            blue: {
                backgroundColor: '$blueT3'
            },
            brown: {
                backgroundColor: '$brownT3'
            },
            maroon: {
                backgroundColor: '$maroonT3'
            },
            yellow: {
                backgroundColor: '$orangeT3'
            },
            pink: {
                backgroundColor: '$graphicBuyingDefault'
            }
        }
    }
});
